<template>
  <el-dialog
    :title="title"
    :visible="
      (visibleModalName !== null &&
        visibleModalName === 'DownloadPaymentsFromBank') ||
      visibleModalName === 'SendAllPaymentsToBank'
    "
    width="30%"
    custom-class="day-add-modal"
    @open="beforeOpen"
    @close="beforeClose"
  >
    <el-row v-if="uploadToBank.payment_ids.length > 0">
      <el-form ref="uploadToBank" :model="uploadToBank" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="Номер первого платежа"
              prop="first_payment_number"
              style="margin-right: 4px"
            >
              <el-input
                v-model="uploadToBank.first_payment_number"
                type="number"
                :rows="5"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p>Количество платежей: {{ uploadToBank.payment_ids.length }}</p>
            <p>Сумма платежей: {{ uploadToBank.sum }} рублей.</p>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="secondary"
        :loading="requestLoading"
        @click="beforeClose"
      >
        Отменить
      </el-button>
      <el-button
        type="primary"
        :loading="requestLoading"
        @click="submitForm('uploadToBank')"
      >
        Подтвердить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { defaultDateRu } from '@/datas/DateFormats'
import { getNow } from '@/helpers/date'
import { mapActions } from 'vuex'
import { paymentMenuItems } from '@/views/TableOfPayments/constants'

export default {
  name: 'PaymentBankModal',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    visibleModalName: {
      type: String || null,
      default: null,
    },
  },
  data() {
    return {
      rules: {
        first_payment_number: [
          {
            required: true,
            message: 'Заполните номер первого платежа',
            trigger: 'change',
          },
        ],
      },
      uploadToBank: {
        sum: 0,
        payment_ids: [],
        first_payment_number: 1,
        export_all: 1,
      },
      downloadToBank: {
        sum: 0,
        payment_ids: [],
        first_payment_number: 1,
      },
      title: '',
      requestLoading: false,
    }
  },
  methods: {
    ...mapActions({
      createPayment: 'tableOfPayments/createPayment',
      createMassPayments: 'tableOfPayments/createMassPayments',
      fetchPaymentsFromBank: 'tableOfPayments/fetchMassPaymentsFromBank',
    }),
    getPayments() {
      this.fetchPaymentsFromBank()
    },
    beforeOpen() {
      this.items.filter(item => {
        if (item.payment_status === 0) {
          this.uploadToBank.sum += item.sum
          this.uploadToBank.payment_ids.push(item.id)
        }
      })
      let modal = paymentMenuItems.filter(
        item => item.name === this.visibleModalName,
      )

      this.uploadToBank.export_all = modal[0].typePayment
      this.title = modal[0].title
    },
    beforeClose() {
      this.uploadToBank = {
        sum: 0,
        payment_ids: [],
        first_payment_number: 1,
        export_all: 1,
      }
      this.downloadToBank = {
        sum: 0,
        payment_ids: [],
        first_payment_number: 1,
      }
      this.title = ''
      this.requestLoading = false
      this.$emit('close')
    },
    submitForm(formName) {
      this.requestLoading = true

      this.$refs[formName].validate(valid => {
        if (valid) {
          const { payment_ids, first_payment_number, export_all } =
            this.uploadToBank

          this.fetchPaymentsFromBank({
            payment_ids,
            first_payment_number,
            export_all,
          })
            .then(response => {
              const dateFrom = getNow(defaultDateRu)

              this.forceFileDownload(
                response,
                `Платежные_документы_${dateFrom}.txt`,
              )
              this.$message.success('Файл сформировался, началось скачивание')
              this.beforeClose()
            })
            .catch(e => this.$message.error(e))
            .finally(() => (this.requestLoading = false))
        } else {
          this.requestLoading = false

          return false
        }
      })
    },
  },
}
</script>

<style lang="sass">
.day-add-modal
  .el-form-item__content
    line-height: 1
  .el-input-number, .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
</style>
